export const STEPS = [
  { id: 1, title: 'Student Info' },
  { id: 2, title: 'School Info' },
  { id: 3, title: 'Key Learning' },
  { id: 4, title: 'Page 2' },
]

export const STEP_FIELDS = {
  1: [
    'studentName', 'oen', 'year', 'date',
    'daysAbsent', 'totalDaysAbsent', 'timesLate', 'totalTimesLate',
  ],
  2: [
    'teacher', 'earlyChildhoodEducator', 'principal', 'telephone',
    'board', 'school', 'schoolAddress', 'boardAddress',
    'frenchProgram',
  ],
  3: [
    'esl', 'iep', 'keyLearningComments',
  ],
  4: [
    'eceNames', 'boardInformation',
  ],
}

export const FIELD_LABELS = {
  date: 'Date',
  studentName: 'Student Name',
  oen: 'OEN',
  year: 'Year (JK / SK)',
  daysAbsent: 'Days Absent',
  totalDaysAbsent: 'Total Days Absent',
  timesLate: 'Times Late',
  totalTimesLate: 'Total Times Late',
  frenchProgram: 'French Program',
  teacher: 'Teacher',
  earlyChildhoodEducator: 'Early Childhood Educator',
  principal: 'Principal',
  telephone: 'Telephone',
  board: 'School Board',
  school: 'School',
  schoolAddress: 'School Address',
  boardAddress: 'Board Address',
  esl: 'ESL',
  iep: 'IEP',
  keyLearningComments: 'Key Learning / Growth in Learning / Next Steps',
  boardInformation: 'Board Information (Page 2)',
  eceNames: 'Early Childhood Educator Names (Page 2)',
}
